import React, { Component } from 'react';





export default class dropdownLap extends Component {
  
  
  private dropdownBtn = document.querySelector('.menu-btn2') as HTMLElement;
  private menuContent = document.querySelector('.menu-content2') as HTMLElement;

  constructor(props : Component) {
    super(props)
    console.log("prout" + this.dropdownBtn);
    
    this.afficher = this.afficher.bind(this);
  }

  
  render() {
    return (
      <div className="dropdown-menu2">
    <button className="menu-btn2" onClick={this.afficher}> Open </button>
    <div className="menu-content2">
    <a className="links2" href="http://mitnoos.com">Site perso</a>
    <a className="links2" href="http://mitnoos.com/CV.pdf">CV</a>
    </div>
    </div>);
  }
  
  afficher() {
    this.dropdownBtn = document.querySelector('.menu-btn2') as HTMLElement;
    this.menuContent = document.querySelector('.menu-content2') as HTMLElement;
    if(this.menuContent !=null && this.dropdownBtn != null) {
      if (this.menuContent.style.display === "") {
        this.menuContent.style.display = "block";
        this.dropdownBtn.textContent = "Close";
        this.dropdownBtn.style.backgroundColor = "#dd0f0f91";
      } else {
        this.menuContent.style.display = "";
        this.dropdownBtn.textContent = "Open";
        this.dropdownBtn.style.backgroundColor = "#479c6b80";
      }
  }
  }

}